import { Badge, Tooltip, Typography } from 'antd'
import type { BadgeProps } from 'antd'
import { useTranslation } from 'react-i18next'
import { useNasHealthReason } from './nasHealthText'
import type { NasHealth, NasHealthState } from './nasApi'

/**
 * RANG — SABABGA qarab, og'irlikka qarab EMAS. Bu panel bo'ylab bir xil
 * qoida (`StatusTag.tsx` dagi `SUSPENDED`/`BLOCKED` ajratmasi).
 *
 *   · `ONLINE`    yashil — qurilmadan chegara ichida aloqa bo'lgan
 *   · `SILENT`    SARIQ  — ochiq sessiyalar bor, lekin Interim kelmay
 *                          qo'ygan. ⚠️ QIZIL EMAS: tarmoqdagi
 *                          vaqtinchalik uzilish ham xuddi shunday
 *                          ko'rinadi va u o'zi tiklanadi. Qizil "odam
 *                          aralashuvi shart" degani bo'lardi
 *   · `IDLE`      kulrang — faol sessiya yo'q, ya'ni eshitadigan narsa
 *                          ham yo'q. Kechasi yopiladigan kafe har kuni
 *                          shu holatda. Buni sariq qilish ogohlantirishga
 *                          umuman ishonmaslikka olib kelardi
 *   · `NO_DATA`   kulrang — o'lchov YO'Q. Yangi qo'shilgan qurilma ham
 *                          shu holatda bo'ladi, ya'ni bu o'z-o'zicha
 *                          nosozlik belgisi emas
 *   · `UNMATCHED` kulrang — belgi umuman olinmagan (manzil IP emas)
 *
 * ⚠️ "Aloqa yo'q" ni QIZIL qilish taklifi ATAYLAB rad etilgan: NAS
 * o'chirilgan bo'lishi mutlaqo qonuniy holat va har kechada qizil
 * ko'rsatiladigan panel bir haftada o'qilmay qo'yadi.
 */
const STATE_BADGE: Record<NasHealthState, BadgeProps['status']> = {
  ONLINE: 'success',
  SILENT: 'warning',
  IDLE: 'default',
  NO_DATA: 'default',
  UNMATCHED: 'default',
}

interface NasHealthTagProps {
  /** `undefined` — belgi hali kelmagan yoki so'rov xato bergan */
  health: NasHealth | undefined
  windowSeconds: number | null
  /** So'rov hali birinchi javobini kutyaptimi */
  loading: boolean
}

/**
 * Jadval katagi — holat + sababi tooltip'da.
 *
 * ⚠️ Belgi kelmasa katak BO'SH qolmaydi: bo'sh katak "hammasi joyida"
 * bo'lib o'qiladi. "—" va tooltip'da sabab — ya'ni panel nimani
 * BILMASLIGINI ham aytadi.
 */
export function NasHealthTag({ health, windowSeconds, loading }: NasHealthTagProps) {
  const { t } = useTranslation()
  const reason = useNasHealthReason()

  if (!health) {
    return (
      <Tooltip title={loading ? t('nas.health.loading') : t('nas.health.unavailable')}>
        <Typography.Text type="secondary">{t('common.dash')}</Typography.Text>
      </Tooltip>
    )
  }

  return (
    <Tooltip title={reason(health, windowSeconds)}>
      <Badge status={STATE_BADGE[health.state]} text={t(`nas.health.state.${health.state}`)} />
    </Tooltip>
  )
}
